import { jsx as _jsx } from "react/jsx-runtime";
import { GroupedListItemTableStyled } from './GroupedListItemTable.styled';
const GroupedListItemTable = (props) => {
    return _jsx(GroupedListItemTableStyled, { stickyHeader: true, size: "medium", cellPaddingInline: "medium", sideCellSpacing: 6, ...props });
};
export { GroupedListItemTable };
